<template>

  <div class="drug-wrap" :class="{'drug-disabled': disabled}">
    <header class="drug-header">
      <p class="title">{{$t('labels.photo')}}</p>
      <ul class="controls">
        <li class="control"
            v-if="oldImg">
          <button type="button" @click="loadOldImg">
            <download-icon class="control-icon" :fill="'rgba(0, 82, 127, .4)'"></download-icon>
          </button>
        </li>
        <li class="control" v-if="!disabled">
          <label>
            <input type="file" @change="changeFile"
                   accept="image/*">
            <reload-icon class="control-icon" :fill="'rgba(0, 82, 127, .4)'"></reload-icon>
          </label>
        </li>
        <li class="control" v-if="!disabled">
          <button type="button"
                  @click="removeFile">
            <del-icon class="control-icon del-icon" :fill="'rgba(0, 82, 127, .4)'"></del-icon>
          </button>
        </li>
      </ul>
    </header>
    <label class="drug-field"
           @click="setEditableOn"
           :style="{backgroundImage: 'url(' + bgLabel + ')'}"
           :class="{'drug-field_active': enterInField,
            'drug-field_loaded': oldImg || fileImg,
            'drug-field_error': typeError || sizeError,
            'drug-active': isEdit}"
           @drop.prevent.stop="dropFile"
           @dragleave.stop.prevent="drugLeave"
           @dragenter.stop.prevent="drugEnter">
      <img src="../assets/loadFile.svg"
           v-if="!fileImg && !bgLabel"
           alt="">
      <input type="file"
             v-if="!disabled"
             @change="changeFile"
             accept="image/*">
<!--      v-if="!fileImg && !bgLabel && !disabled"-->
      <div class="text-cont" v-if="!fileImg && !bgLabel && !newAvatar">
        <p class="text error" v-if="typeError">{{$t('errors.uploadError')}}</p>
        <errors v-else-if="sizeError" class="text error" :type="'fileSize'" :min-length="1.5"></errors>
        <p class="text" v-else>{{$t('forms.upload1')}} <span>{{$t('forms.upload2')}}</span> {{$t('forms.upload3')}}</p>
      </div>
    </label>
  </div>
</template>

<script>
  import delIcon from './Svg/cart_control/delIcon'
  import downloadIcon from './Svg/uploadControls/downloadicon'
  import reloadIcon from './Svg/uploadControls/reloadIcon'
  import errors from './Forms/errors'
  import {tokenAndRoute} from "../mixins/utils/tokenAndRoute";
  import {mapMutations, mapState, mapActions} from 'vuex'


  export default {
    name: 'uploadFileBig',
    props: {
      oldImg: {
        type: String,
        required: false
      },
      disabled: {
        type: Boolean
      }
    },
    mixins: [tokenAndRoute],
    components: {
      delIcon,
      downloadIcon,
      reloadIcon,
      errors
    },
    data() {
      return {
        enterInField: false,
        typeError: false,
        sizeError: false,
        fileImg: ''
      }
    },
    computed: {
      ...mapState({
        isEdit: state => state.things.onSettingsNodeEdit,
        newAvatar: state => state.things.newAvatar,
      }),
      bgLabel() {
        if (!this.fileImg) {
          return this.oldImg
        } else {
          return this.fileImg;
        }
      }
    },
    watch: {
      routeId() {
        this.fileImg = ''
      }
    },
    methods: {
      ...mapMutations({
        setEditedFields: 'things/SET_ON_EDITING_INPUTS',
        setSettingsNodeEditable: 'things/SET_SETTINGS_NODE_EDITABLE',
        setHeaderSettingsEditActive: 'things/SET_HEADER_SETTINGS_EDIT_ACTIVE'
      }),
      setEditableNodeSettings(val) {
        this.setSettingsNodeEditable(val);
        this.setHeaderSettingsEditActive(val)
      },
      setEditableOn() {
        this.setEditableNodeSettings(true)
      },
      drugEnter() {
        this.enterInField = true;
        this.typeError = false;
        this.sizeError = false;
      },
      drugLeave() {
        this.enterInField = false
      },
      dropFile(e) {
        let file = e.dataTransfer.files[0];
        this.enterInField = false;
        this.uploadFile(file)
      },
      changeFile(e) {
        const fileList = e.target.files;
        const thisFile = fileList[fileList.length - 1];
        this.uploadFile(thisFile)
      },
      uploadFile(file) {
        const maxSizeMB = 1572864;
        this.typeError = false;
        this.sizeError = false;

        if (file) {
          let fileType = file.type;

          //image/gif, image/jpg, image/jpeg, image/png
          function checkType(type) {
            return (type === 'image/gif' ||
              type === 'image/jpg' ||
              type === 'image/jpg' ||
              type === 'image/jpeg' ||
              type === 'image/png')
          }

          if (!checkType(fileType)) {
            this.typeError = true
          }
          ;

          let imgSize = file.size;

          if (imgSize < maxSizeMB) {
            let cntx = this;
            const reader = new FileReader();
            reader.onload = function (event) {
              const contents = event.target.result;
              cntx.fileImg = contents
            };

            reader.readAsDataURL(file);
            this.$emit('upload', file);
          } else {
            this.sizeError = true
          }
        }
      },
      removeFile() {
        this.fileImg = '';
        this.oldImg = '';
        this.$emit('del')
        // this.setNewAvatar('')
      },
      loadOldImg() {
        let link = document.createElement('a');
        link.style.display = 'none';
        document.body.appendChild(link);
        link.setAttribute('href', this.oldImg);
        link.setAttribute('target', '_blank')
        link.setAttribute('download', 'avatar');
        link.click();
        document.removeChild(link);
      }
    },
    mounted() {
      function preventDefaults(e) {
        e.preventDefault();
        e.stopPropagation();
      }
      ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
        document.addEventListener(eventName, preventDefaults, false)
      })
    }
  }
</script>

<style lang="scss" scoped>
  .drug-header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    justify-content: space-between;
  }

  .controls {
    display: flex;
    align-items: center;
    margin: 0 -5px;

    .control {
      margin: 0 5px;
      width: 20px;
      height: 20px;


      .del-icon {
        width: 75%;
      }
    }
  }

  .drug-field {
    border: 2px dashed rgba(16, 156, 241, .4);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 220px;
    width: 220px;
    /*padding-top: 56px;*/
    justify-content: center;
    box-sizing: border-box;
    transition: $anim;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;

    img {
      max-width: 61px;
      margin-bottom: 36px;
      opacity: .36;
    }
  }


  .drug-field_error {
    border: 2px dashed $red;
    height: 220px;
    width: 220px;
    cursor: pointer;
  }

  .drug-field_loaded {
    border: none;
    height: 220px;
    width: 220px;
  }

  .drug-field_active {
    border:2px solid rgba(16, 156, 241, .15);
    position: relative;

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 2;
      background: rgba(16, 156, 241, .15);
      border-radius: 8px;
    }
  }


  .text {
    font-family: $mm;
    font-size: 14px;
    letter-spacing: .25px;
    color: $lightBlue;
    text-align: center;

    span {
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .title {
    font-family: $mr;
    font-size: 13px;
    opacity: .5;
    margin: 0;
  }

  .error {
    color: $red;
  }

  input {
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
    z-index: -999;
  }

  .drug-disabled {
    /*.drug-field  img {
      margin-bottom: 0;
    }

    .drug-field {
      padding: 0;
      display: flex;
      justify-content: center;
      align-self: center;
      border: 1px solid $lightBlue;
    }

    .drug-field_loaded {
      border: none;
    }*/

  }
  /*.drug-field {*/
  /*  cursor: pointer;*/
  /*}*/
  .drug-active {
    border: none;
    background-color: rgba(16, 156, 241, .15);
    cursor: pointer;
  }


  .text-cont {
    font-family: $mm;
    padding-left: 14px;
    padding-right: 14px;
    font-size: 12px;
    line-height: 18px;
  }
</style>

<style lang="scss">
.control {
  svg:hover path {
    fill: #29ABE2;
  }
}
</style>
